document.addEventListener('DOMContentLoaded', function () {
    const headers = document.querySelectorAll('.home-accordion-section__accordion-list-item-header');

    headers.forEach((header) => {
        header.addEventListener('click', function () {
            const content = header.nextElementSibling;
            const isOpen = header.classList.contains('active');

            // Close any other open accordion items
            document.querySelectorAll('.home-accordion-section__accordion-list-item-header.active').forEach((activeHeader) => {
                if (activeHeader !== header) {
                    closeAccordion(activeHeader, activeHeader.nextElementSibling);
                }
            });

            // Toggle the clicked item
            if (isOpen) {
                closeAccordion(header, content);
            } else {
                openAccordion(header, content);
            }
        });
    });

    function openAccordion(header, content) {
        header.classList.add('active');
        // Set the height to the scrollHeight to animate opening
        content.style.height = content.scrollHeight + 'px';

        // When the transition ends, remove the inline height if open so it can adapt if content changes.
        content.addEventListener('transitionend', function handler(e) {
            if (e.propertyName === 'height' && header.classList.contains('active')) {
                content.style.height = 'auto';
            }
            content.removeEventListener('transitionend', handler);
        });
    }

    function closeAccordion(header, content) {
        header.classList.remove('active');

        // For a smooth close, if the height is 'auto' we first set it to the current pixel height.
        if (content.style.height === 'auto') {
            content.style.height = content.scrollHeight + 'px';
            // Force reflow to apply the new fixed height
            content.offsetHeight;
        }
        // Then animate to 0
        content.style.height = '0px';
    }

    // Select the container where you want the custom cursor active.
    const container = document.querySelector('.home-accordion-section-inner');
    const cursorTitle = container.dataset.cursorTitle;
    const cursorColor = container.dataset.cursorColor;

    // Create and append the custom cursor circle
    const customCursor = document.createElement('div');
    customCursor.classList.add('custom-cursor');
    container.appendChild(customCursor);

    // Create and append the custom text element (update the text as needed)
    const customCursorText = document.createElement('div');
    customCursorText.classList.add('custom-cursor-text');
    customCursorText.classList.add('maus');
    customCursorText.innerHTML = cursorTitle; // Replace with your desired text
    customCursor.appendChild(customCursorText); // Append to customCursor instead of container
    customCursor.style.opacity = 0;
    customCursorText.style.opacity = 0;
    customCursorText.style.color = cursorColor;
    customCursor.style.backgroundColor = cursorColor;

    // Update positions on mouse move within the container
    container.addEventListener('mousemove', function (e) {
        // If the mouse is over an excluded element, hide the custom cursor.
        if (e.target.closest('.home-accordion-section__accordion-list')) {
            customCursor.style.opacity = 0;
            customCursorText.style.opacity = 0;
            return;
        }

        // Get container boundaries
        const containerRect = container.getBoundingClientRect();

        // Get the actual mouse position
        const mouseX = e.clientX;
        const mouseY = e.clientY;

        // Set the cursor position directly
        customCursor.style.left = mouseX + 'px';
        customCursor.style.top = mouseY + 'px';

        // Define constant offsets for the text
        const offsetX = 15; // Fixed distance from cursor

        // Calculate right edge of the container relative to cursor
        const distanceFromRightEdge = containerRect.right - mouseX;

        // Get text width (approximate if not yet visible)
        const estimatedTextWidth = customCursorText.offsetWidth || 80; // fallback to 80px if not yet measured

        // Check if we're too close to the right edge of container
        const tooCloseToRight = distanceFromRightEdge < estimatedTextWidth + offsetX + 15;

        // Check if we're too close to the bottom edge
        const distanceFromBottomEdge = containerRect.bottom - mouseY;
        const tooCloseToBottom = distanceFromBottomEdge < 30;

        // Set text horizontal placement - fixed positions for each state
        if (tooCloseToRight) {
            // Use a fixed position when near right edge
            customCursorText.style.right = '15px';
            customCursorText.style.left = 'auto';
        } else {
            // Fixed right-side position when not near edge
            customCursorText.style.left = offsetX + 'px';
            customCursorText.style.right = 'auto';
        }

        // Set text vertical placement
        if (tooCloseToBottom) {
            // Place text above cursor
            customCursorText.style.top = '-20px';
        } else {
            // Place text below/aligned with cursor
            customCursorText.style.top = '-3px';
        }

        // Make cursor and text visible
        customCursor.style.opacity = 1;
        customCursorText.style.opacity = 1;
    });

    // Hide the custom cursor when leaving the container
    container.addEventListener('mouseleave', function () {
        customCursor.style.opacity = 0;
        customCursorText.style.opacity = 0;
    });

    // Add Intersection Observer for first accordion
    const firstAccordionHeader = document.querySelector('.home-accordion-section__accordion-list-item-header');

    if (firstAccordionHeader) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        // Wait 500ms before opening
                        setTimeout(() => {
                            const content = firstAccordionHeader.nextElementSibling;
                            openAccordion(firstAccordionHeader, content);
                        }, 500);

                        // Disconnect observer after first intersection
                        observer.disconnect();
                    }
                });
            },
            {
                threshold: 0.5, // Trigger when 50% of element is visible
            },
        );

        observer.observe(firstAccordionHeader);
    }
});
